import { render } from "./UndanganView.vue?vue&type=template&id=61b6f478&scoped=true"
import script from "./UndanganView.vue?vue&type=script&lang=js"
export * from "./UndanganView.vue?vue&type=script&lang=js"

import "./UndanganView.vue?vue&type=style&index=0&id=61b6f478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b6f478"]])

export default __exports__